import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import cartNotesService from '../../services/cartNotes';

const initialState = {
  loading: false,
  notes: [],
  error: '',
  params: {
    page: 1,
    perPage: 100,
  },
  meta: {},
};

export const fetchCartNotes = createAsyncThunk(
  'cartNotes/fetchCartNotes',
  (params = {}) => {
    return cartNotesService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  },
);

export const createCartNote = createAsyncThunk(
  'cartNotes/createCartNote',
  (data) => {
    return cartNotesService.create(data).then((res) => res);
  },
);

export const updateCartNote = createAsyncThunk(
  'cartNotes/updateCartNote',
  ({ id, data }) => {
    return cartNotesService.update(id, data).then((res) => res);
  },
);

const cartNotesSlice = createSlice({
  name: 'cartNotes',
  initialState,
  reducers: {
    clearCartNotes(state) {
      state.notes = [];
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    // Fetch cart notes
    builder.addCase(fetchCartNotes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCartNotes.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.notes = payload.data || [];
      state.meta = payload.meta || {};
      state.error = '';
    });
    builder.addCase(fetchCartNotes.rejected, (state, action) => {
      state.loading = false;
      state.notes = [];
      state.error = action.error.message;
    });

    // Create cart note
    builder.addCase(createCartNote.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createCartNote.fulfilled, (state, action) => {
      state.loading = false;
      const newNote = action.payload.data;
      if (newNote) {
        // Add new note to the beginning of the array
        state.notes = [newNote, ...state.notes];
      }
      state.error = '';
    });
    builder.addCase(createCartNote.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    // Update cart note
    builder.addCase(updateCartNote.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCartNote.fulfilled, (state, action) => {
      state.loading = false;
      const updatedNote = action.payload.data;
      if (updatedNote) {
        const index = state.notes.findIndex((n) => n.id === updatedNote.id);
        if (index !== -1) {
          state.notes[index] = updatedNote;
        }
      }
      state.error = '';
    });
    builder.addCase(updateCartNote.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export const { clearCartNotes } = cartNotesSlice.actions;
export default cartNotesSlice.reducer;

